import {
    GET_RISELABEL_ERROR,
    GET_RISELABEL_REQUEST,
    GET_RISELABEL_SUCCESS,
    ADD_RISELABEL_ERROR,
    ADD_RISELABEL_REQUEST,
    ADD_RISELABEL_SUCCESS,
    DELETE_RISELABEL_REQUEST,
    DELETE_RISELABEL_SUCCESS,
    DELETE_RISELABEL_ERROR,
    UPDATE_RISELABEL_ERROR,
    UPDATE_RISELABEL_REQUEST,
    UPDATE_RISELABEL_SUCCESS,
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");
export const getRiseLabel = (token, menu_id) => (dispatch) => {
    dispatch({ type: GET_RISELABEL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/rise_label`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id }
    })
        .then((response) => {
            return dispatch({ type: GET_RISELABEL_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_RISELABEL_ERROR,
                payload: error.response,
            });
        });
};

export const addRiseLabel = (token, data, menu_id) => (dispatch) => {
    dispatch({ type: ADD_RISELABEL_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/rise_label`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { rise_label_name: data.riseLabelName, is_active: data.check, menu_id },
    })
        .then((response) => {
            return dispatch({ type: ADD_RISELABEL_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_RISELABEL_ERROR,
                payload: error.response,
            });
        });
};
export const updateRiseLabel = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_RISELABEL_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/rise_label/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { rise_label_name: data.riseLabelName, is_active: data.check },
    })
        .then((response) => {
            return dispatch({ type: UPDATE_RISELABEL_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_RISELABEL_ERROR,
                payload: error.response,
            });
        });
};

export const deleteRiseLabel = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_RISELABEL_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/rise_label/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_RISELABEL_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_RISELABEL_ERROR,
                payload: error.response,
            });
        });
};
